// extracted by mini-css-extract-plugin
module.exports = {"container":"banner-image_container___FnN7","image":"banner-image_image__XgjOd","content":"banner-image_content___1hKm"};